<template>
    <el-dialog
            title=""
            :visible.sync="isLoginShow"
            :close-on-click-modal="false"
            :before-close="handleDialogClose"
            custom-class="dialogRadius"
            :destroy-on-close="true"
            @close="handleDialogClose"
            width="500px">
        <div class="dialog-cont">
            <div class="login-tit" v-if="showType==1||showType==2">
                <span @click="showType=1" :class="showType==1?'active':''">手机登录</span>| <span @click="showType=2" :class="showType==2?'active':''">密码登录</span>
            </div>
            <div class="login-tit"  v-if="showType==3||showType==4||showType==5" v-text="showType==3?'用户注册':showType==4?'重置密码':'设置支付密码'"></div>
            <div class="form-group">
                <div class="row-group">
                    <input type="text" placeholder="手机号码" v-model="form.phone" class="form-input" @change="inputUpdate" autocomplete="off" />
            </div>
                <div class="row-group" v-if="showType!==2">
                    <input type="text" placeholder="验证码" v-model="form.code"  class="form-input" @change="inputUpdate" autocomplete="off" />
                    <SendSms :mobile="form.phone" :smsType="getSmsType"></SendSms>
                </div>
                <div class="row-group" v-if="showType!==1&&showType!==5">
                    <input type="password" :placeholder="showType==2?'密码':showType==4?'设置新密码':'设置密码'" v-model="form.password" class="form-input" @keyup.enter="goLogin()" @change="inputUpdate" autocomplete="off" />
                </div>
                <div class="row-group" v-if="showType==5">
                    <input type="password" placeholder="设置密码" v-model="form.payPassword" class="form-input" @change="inputUpdate" autocomplete="off" />
                </div>
            </div>
            <div class="forget" v-show="showType==1||showType==2" @click="showType=4"><a>忘记密码?</a></div>
            <button type="button" class="btn-login" v-show="showType==1||showType==2" @click="goLogin()">登录</button>
            <button type="button" class="btn-login btn-reg" v-show="showType==3" @click="goReg()">注册</button>
            <button type="button" class="btn-login btn-reg" v-show="showType==4" @click="resetPass()">提交</button>
            <button type="button" class="btn-login btn-reg" v-show="showType==5" @click="resetPayPass()">保存</button>
            <p class="go-reg" v-show="showType==1||showType==2">还没有账号? <a class="btn-go-reg" @click="showType=3">去注册</a></p>
            <p class="go-reg" v-show="showType==3||showType==4">已有账号?<a class="btn-go-reg" @click="showType=1">去登录</a></p>
        </div>
    </el-dialog>
</template>
<script>
    import SendSms from '../sendSms'
    import {editPassword,editPayPassword} from '../../api/user'
    export default {
        props:{
            /*loginDialogVisible:{
                type:Boolean,
                default:false
            },*/
            type:{
                type:Number,
                default:1
            }
        },
        computed:{
            isLoginShow(){
                return this.$store.state.isLoginShow;
            },
            getSmsType() {
                let type = '';
                switch (this.showType) {
                    case 1:
                        type = 'code';
                        break;
                    case 3:
                        type = 'reg';
                        break;
                    case 4:
                        type = 'find';
                        break;
                    case 5:
                        type = 'pay';
                        break;
                }
                return type;
            }
        },
        components:{
            SendSms
        },
        data(){
            return {
                showType:1,//1:验证码登录；2：密码登录；3：注册；4:重置密码；
                formLabelWidth:'120px',
                form:{
                    phone:'',
                    code:'',
                    password:'',
                    payPassword:''
                }
            }
        },
        methods:{
            inputUpdate(e){
//                this.$forceUpdate();
            },
            handleDialogClose(){
                this.$store.commit('changeLoginShow',false);
            },
            regPhone(){
                let regPhone=/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
                if(!regPhone.test(this.form.phone)){
                    this.$alert('请输入11位手机号', '提示', {
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }else{
                    return true;
                }
            },
            goReg(){
                let params = JSON.parse(JSON.stringify(this.form));
                delete params.payPassword;
                if(!this.regPhone()){
                    return;
                }
                if(params.code.length==0){
                    this.$alert('请输入验证码', '提示');return false;
                }
                if(params.password.length==0){
                    this.$alert('请输入密码', '提示');return false;
                }
                this.$store.dispatch("goRegister",params).then( res => {
                    /*this.userInfo=res.data.user;*/
                    this.goHome();
                })
            },
            goLogin(){
                let params = JSON.parse(JSON.stringify(this.form));
                delete params.payPassword;
                if(!this.regPhone()){
                    return;
                }
                if(this.showType==1){
                    if(params.code.length==0){
                        this.$alert('请输入验证码', '提示');return false;
                    }
                    this.$store.dispatch("goLoginByCode",params).then( res => {
                        /*this.userInfo=res.data.user;*/
                        this.goHome();
                    })
                }
                if(this.showType==2){
                    if(params.password.length==0){
                        this.$alert('请输入密码', '提示');return false;
                    }
                    this.$store.dispatch("goLogin",params).then( (res) => {
                        //console.log(res)
                        /*this.userInfo=res.data.user;*/
                        this.goHome();
                    })
                }
            },
            resetPass(){
                let params = JSON.parse(JSON.stringify(this.form));
                delete params.payPassword;
                if(!this.regPhone()){
                    return;
                }
                if(params.code==''){
                    this.$alert('请输入验证码', '提示');return false;
                }
                if(params.password==''){
                    this.$alert('请输入密码', '提示');return false;
                }
                editPassword(params).then( res => {
                    /*this.userInfo=res.data.user;*/
                    this.goHome();
                })
            },
            resetPayPass(){
                let params = JSON.parse(JSON.stringify(this.form));
                delete params.password;
                if(!this.regPhone()){
                    return;
                }
                if(params.code==''){
                    this.$alert('请输入验证码', '提示');return false;
                }
                if(params.payPassword==''){
                    this.$alert('请输入密码', '提示');return false;
                }
                if(params.payPassword.length!==6){
                    this.$alert('请输入6位支付密码', '提示');return false;
                }
                editPayPassword(params).then( res => {
                    this.$message({
                        type: 'success',
                        message: '设置密码成功！'
                    });
                    this.$store.dispatch('getMeInfoData')
                    this.$store.commit('changeLoginShow',false);
                })
            },
            goHome(){
                this.$router.push({ path: '/' });
                this.$store.commit('changeLoginShow',false);
            }
        }

    }
</script>
<style lang="scss" scoped>
    @import "../../assets/css/common";
    .el-dialog.dialogRadius{
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
    }
    .dialog-cont{
        padding:0 62px;
        .login-tit{
            padding:10px 0 50px;
            color:#666666;
            font-size:28px;
            span:first-child{padding-right:40px;text-align: left}
            span:last-child{padding-left:40px}
            .active{
                color: #333333;
            }
        }
        .form-group{
            font-size:16px;
            color:#999999;
            .form-input{
                &::-webkit-input-placeholder { /* WebKit browsers */
                    color: #999;
                    font-size: 16px;
                }

                &::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: #999;
                    font-size: 16px;
                }

                &:-ms-input-placeholder { /* Internet Explorer 10+ */
                    color: #999;
                    font-size: 16px;
                }
            }
            .row-group{
                border-bottom:2px solid rgba(237,237,237,1);
                position: relative;
                padding: 38px 10px 0;
                .form-input{
                    border:none;
                    width:100%;
                    line-height:50px;
                }
                /*.btn-send{
                    position: absolute;
                    bottom:18px;
                    right:0;
                    color:#333333;
                }*/
            }
        }
        .forget{
            a{color:$main-color}
            font-size:16px;
            padding:36px 0 51px;
            text-align: right;
        }
        .btn-login{
            width:100%;
            height:51px;
            line-height:51px;
            font-size:16px;
            background-color:$main-color;
            color:#ffffff;
            -webkit-border-radius: 25.45px;
            -moz-border-radius: 25.45px;
            border-radius: 25.45px;
        }
        .btn-reg{
            margin-top:37px;
        }
        .go-reg{
            color:#999999;
            font-size:18px;
            text-align:center;
            padding:30px 0 2px;
            .btn-go-reg{
                color:$main-color;
            }
        }
    }

</style>